import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-180" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-181" data-mp="o3xb3cmzv1ct">
        <SectionHeading id="summary-title" data-id="element-182" data-mp="j887my7ut0b8">Everything <span className="text-copper" data-id="element-183" data-mp="j5c7r4cg41k5">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-steel/60 bg-navy-900 sm:grid-cols-2" data-id="element-184" data-mp="1gufaa2klkiky">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-steel/15 p-4 sm:odd:border-r" data-id="element-185" data-mp="16whlndytsjrt">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-copper" data-id="element-186" data-mp="12vpcsltv8gw2">
                <CheckIcon className="h-3.5 w-3.5 text-navy-950" aria-hidden="true" data-id="element-187" data-mp="3rn8kikyiw2ed" />
              </span>
              <b className="text-sm text-white" data-id="element-188" data-mp="3nkbwufu4lg3k">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}